export const menuItems = [
  {
    label: "Dashboard",
    perm: "view_dashboard",
    icon: "mdi mdi-apps",
    link: "/",
  },
  {
    label: "Sales",
    icon: "bx bx-money",
    perm: "view_sales",
    subItems: [
      {
        label: "Add a Sale",
        perm: "add_sales",
        link: "/sellproduct",
      },
      {
        label: "View Sales",
        perm: "view_sales_info",
        link: "/viewsales",
      },
      {
        label: "Customers",
        perm: "add_customer",
        link: "/customers",
      },

      // {
      //   label: "Debtors",
      //   perm: "patient_visits",
      //   link: "/debtors",
      // },
    ],
  },
  {
    label: "Medicine",
    icon: "bx bxs-capsule",
    perm: "view_medicine",
    subItems: [
      {
        label: "Products",
        perm: "view_products",
        link: "/products",
      },
      {
        label: "Categories",
        perm: "view_categories",
        link: "/productcategories",
      },
      {
        label: "Units",
        perm: "view_categories",
        link: "/productunits",
      },
      // {
      //   label: "Product Items Units",
      //   perm: "view_categories",
      //   link: "/productitems",
      // },
    ],
  },
  {
    label: "Inventory",
    icon: "bx bx-store-alt",
    perm: "view_inventory",
    subItems: [
      {
        label: "Add Stock",
        perm: "add_stock",
        link: "/addstock",
      },
      {
        label: "Stock Purchases",
        perm: "add_stock",
        link: "/purchases",
      },
      {
        label: "Batch Levels",
        perm: "view_stock_levels",
        link: "/stocklevels",
      },
      {
        label: "System Stock",
        perm: "view_stock_levels",
        link: "/systemstock",
      },
      {
        label: "Reconcile Stock",
        perm: "reconcile_stock",
        link: "/reconcilestock",
      },
      {
        label: "View Stock ",
        perm: "view_stock_levels",
        link: "/viewstocks",
      },
      {
        label: "View Suppliers",
        perm: "view_suppliers",
        link: "/suppliers",
      },
      {
        label: "Expired Stock",
        perm: "add_stock",
        link: "/expiredstock",
      },
    ],
  },
  {
    label: "Expenses",
    icon: "bx bxs-wallet",
    perm: "view_expenses",
    subItems: [
      {
        label: "Add an Expense",
        perm: "add_expense",
        link: "/recordexpense",
      },
      {
        label: "Expenses",
        perm: "view_expenses",
        link: "/viewexpenses",
      },
      {
        label: "Categories",
        perm: "expense_categories",
        link: "/expensecategories",
      },
      {
        label: "Expense Items",
        perm: "expense_categories",
        link: "/expenseitems",
      },
    ],
  },
  {
    label: "System Settings",
    icon: "bx bxs-cog",
    perm: "view_settings",
    subItems: [
      {
        label: "System Users",
        perm: "view_settings",
        link: "/users",
      },
      {
        label: "System Roles",
        perm: "view_settings",
        link: "/roles",
      },
      {
        label: "Permissions",
        perm: "view_settings",
        link: "/permissions",
      },
      {
        label: "Audit Trails",
        perm: "view_settings",
        link: "/audits",
      },
      {
        label: "Facility Profile",
        perm: "view_settings",
        link: "/facilityprofile",
      },
      {
        label: "Facility Settings",
        perm: "view_settings",
        link: "/facilitysettings",
      },
      {
        label: "Payment Options",
        perm: "view_settings",
        link: "/paymentoptions",
      },
    ],
  },
];
